export enum Status {
  Available = 1,
  Pending = 2,
}
